export const CloseModalOnEscapeMixin = {
    methods: {
        /**
         * Pressing escape will cancel the modal.
         * This escPressed method is called by the OverlayStack component
         * when escape is pressed if this is the topmost modal.
         */
        escPressed() {
            this.cancel();
        },
    },
};
